interface PricingTier {
	name: string;
	price: number;
	duration: string;
	features: string[];
}

const pricingTiers: PricingTier[] = [
	{
		name: "Rapid MVP",
		price: 800,
		duration: "1 day",
		features: [
			"AI-powered rapid development",
			"Basic cloud deployment",
			"2 revision rounds",
			"Priority support",
			"Basic SEO optimization",
			"Basic analytics integration"
		]
	},
	{
		name: "Professional MVP",
		price: 4999,
		duration: "1 week",
		features: [
			"Everything in Rapid MVP",
			"Advanced UI/UX design",
			"Custom domain setup",
			"Performance optimization",
			"API integration",
			"Database setup",
			"4 revision rounds",
			"30 days of maintenance"
		]
	},
	{
		name: "Enterprise MVP",
		price: 9999,
		duration: "2 weeks",
		features: [
			"Everything in Professional MVP",
			"Mobile app development",
			"CI/CD pipeline setup",
			"Auto-scaling configuration",
			"Advanced security features",
			"Load testing & optimization",
			"Monitoring & alerts setup",
			"6 months of maintenance",
			"24/7 priority support"
		]
	}
];

interface PricingGridProps {
	onSelectPackage: (packageName: string, timeline: string) => void;
}

export const PricingGrid = ({ onSelectPackage }: PricingGridProps) => {
	const scrollToContact = () => {
		const contactForm = document.getElementById('contact-form');
		if (contactForm) {
			contactForm.scrollIntoView({ behavior: 'smooth' });
		}
	};

	const handleGetStarted = (tier: PricingTier) => {
		onSelectPackage(tier.name, tier.duration);
		scrollToContact();
	};

	return (
		<div className="max-w-7xl mx-auto grid grid-cols-1 gap-8 md:grid-cols-3 mb-16">
			{pricingTiers.map((tier) => (
				<div key={tier.name} className="card flex flex-col">
					<div className="flex-grow">
						<h3 className="text-2xl font-bold mb-4">{tier.name}</h3>
						<p className="text-4xl font-bold mb-6">${tier.price}</p>
						<p className="text-gray-300 mb-6">{tier.duration}</p>
						<ul className="space-y-3 mb-8">
							{tier.features.map((feature) => (
								<li key={feature} className="flex items-center">
									<svg className="h-5 w-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
									</svg>
									{feature}
								</li>
							))}
						</ul>
					</div>
					<button 
						onClick={() => handleGetStarted(tier)}
						className="btn w-full mt-auto"
					>
						Get Started
					</button>
				</div>
			))}
		</div>
	);
};
